module.exports = __webpack_public_path__ + "img/finish-check.b5112415.svg";